"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _selectedPersonas = require("../../actions/selectedPersonas");

var _groupedPersona = require("../../actions/groupedPersonas/groupedPersona");

var _campaignCreator = require("../../actions/campaignCreator");

var _PersonaFilterTagList = _interopRequireDefault(require("../../components/persona/PersonaFilterTagList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CampaignPersonaFilterTagList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CampaignPersonaFilterTagList, _React$Component);

  function CampaignPersonaFilterTagList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CampaignPersonaFilterTagList.prototype;

  _proto.render = function render() {
    var _this$props$themesFor = this.props.themesFor,
        themesFor = _this$props$themesFor === void 0 ? 'profiling' : _this$props$themesFor;
    var resetTheme, resetShareOfAttribute, resetShareOfAudience, resetIndex, resetPopulation;

    if (themesFor === 'media') {
      resetTheme = this.props.resetMediaTheme;
      resetShareOfAttribute = this.props.resetMediaShareOfAttribute;
      resetShareOfAudience = this.props.resetMediaShareOfAudience;
      resetIndex = this.props.resetMediaIndex;
      resetPopulation = this.props.resetMediaPopulation;
    } else {
      resetTheme = this.props.resetTheme;
      resetShareOfAttribute = this.props.resetShareOfAttribute;
      resetShareOfAudience = this.props.resetShareOfAudience;
      resetIndex = this.props.resetIndex;
      resetPopulation = this.props.resetPopulation;
    }

    return /*#__PURE__*/React.createElement(_PersonaFilterTagList["default"], _extends({}, this.props, {
      resetTheme: resetTheme,
      resetShareOfAttribute: resetShareOfAttribute,
      resetShareOfAudience: resetShareOfAudience,
      resetIndex: resetIndex,
      resetPopulation: resetPopulation
    }));
  };

  return CampaignPersonaFilterTagList;
}(React.Component); // get something out of global store


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    selectedPersonas: state.selectedPersonas.personas,
    findPersonasSelected: state.findPersonasSelected.selectedPersonas,
    isDataPage: state.options.isDataPage.value
  };
}; // bind our actions into redux (allow them to talk to redux)


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    removeSelectedPersona: _selectedPersonas.removeSelectedPersona,
    loadGroupedPersona: _groupedPersona.loadGroupedPersona,
    resetShareOfAttribute: _campaignCreator.resetShareOfAttribute,
    resetMediaShareOfAttribute: _campaignCreator.resetMediaShareOfAttribute,
    resetShareOfAudience: _campaignCreator.resetShareOfAudience,
    resetMediaShareOfAudience: _campaignCreator.resetMediaShareOfAudience,
    resetIndex: _campaignCreator.resetIndex,
    resetMediaIndex: _campaignCreator.resetMediaIndex,
    resetPopulation: _campaignCreator.resetPopulation,
    resetMediaPopulation: _campaignCreator.resetMediaPopulation,
    resetTheme: _campaignCreator.resetTheme,
    resetMediaTheme: _campaignCreator.resetMediaTheme
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignPersonaFilterTagList);

exports["default"] = _default;